export default "__VITE_ASSET__2cefe674__"